import React from "react";


import axios from 'axios';
import {BdnbApiApi, Configuration} from "./generated";
import {serverUrl} from "./Serveur";


const config = new Configuration();
const axiosInstance = axios.create({});

const ctrlApi = new BdnbApiApi(config, serverUrl, axiosInstance);

export default class BdnbCtrl extends React.Component {



    static async getSyntheseBdnb(ban, callback) {
        ctrlApi.bdnbSynthesesBanIdGet(ban).then((result) => {
            callback(result.data);
        })
    }

    static async getIrisStats(ban, callback) {
        ctrlApi.bdnbSynthesesByIrisGet(ban).then((result) => {
            callback(result.data);
        })
    }

    static async getInseeStats(ban, callback) {
        ctrlApi.bdnbSynthesesByCodeInseeGet(ban).then((result) => {
            callback(result.data);
        })
    }


}
